<div class="hub-similar-calendar">

    <div *ngIf="!isNoContent" class="similar-tips">
        <mat-icon>help_outline</mat-icon>
        <div>
            <p>Places in the same row are considered similar</p>
        </div>
    </div>

    <mat-tab-group>
        <mat-tab>
            <ng-template mat-tab-label>
                Similar Places
            </ng-template>
            <div class="m-t-3">
                <div *ngFor="let groupWithCondition of similarPlaces" class="similar-row">
                    <div *ngFor="let place of groupWithCondition.group" class="similar-card">
                        <div class="approved e-status" *ngIf="place.isApproved">approved</div>
                        <div class="unapproved e-status" *ngIf="!place.isApproved">pending approval</div>
                        <div class="manual e-status">{{ place.isManuallyCreated ? 'Manual' : 'Google' }}</div>

                        <div class="operation">
                            <ig-card-action *ngIf="!place.isApproved" icon="done" matTooltip="Approve"
                                matTooltipPosition="right" (click)="approve(place)">
                            </ig-card-action>
                            <ig-card-action *ngIf="place.isApproved" icon="clear" matTooltip="Unapprove"
                                matTooltipPosition="right" (click)="unApprove(place)">
                            </ig-card-action>
                            <ig-card-action icon="edit" matTooltip="Edit" matTooltipPosition="right"
                                (click)="showEditModal(place)">
                            </ig-card-action>
                            <ig-card-action icon="delete_forever"
                                matTooltip="Remove this place to your remove list,events that are removed can be reverted as needed."
                                matTooltipPosition="right" (click)="block(place)">
                            </ig-card-action>
                        </div>

                        <ig-image [imageUrl]="place.cover?.source"></ig-image>
                        <p>
                            {{ place.name }}
                        </p>
                        <p>
                            {{ place.address }}
                        </p>
                    </div>
                </div>
                <div *ngIf="hasMoreGroups" class="flex m-t-4 m-b-5 flex-col items-center gap-2 light-gray-text m-b-6">
                    <p>In order to improve performance, the Similar Places are checking by groups</p>
                    <p><span *ngIf="group>=0">Total places: {{ allPlaceCount }}, </span> Group size: {{ groupSize }},
                        Current group
                        number: {{ group + 1 }}</p>
                    <p>Please click on the "{{group === -1 ? 'Start Checking' : 'Load More'}}" button to check {{group
                        === -1 ? '' : 'more'}} places</p>
                    <ig-button (trigger)="getSimilarPlaces($event)" [isAsync]="true" style="width: 200px"
                        class="m-t-2 m-b-6">
                        {{group === -1 ? 'Start Checking' : 'Load More'}}
                    </ig-button>
                </div>
                <div *ngIf="!hasMoreGroups" class="m-t-2 flex justify-center light-gray-text m-b-5">
                    All data loaded
                </div>

                <ig-no-content *ngIf="isNoContentForMultiDatesEvents"></ig-no-content>
            </div>
        </mat-tab>

    </mat-tab-group>
    <ng-container>
        <ig-page-spinner #spinner></ig-page-spinner>
    </ng-container>

</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/similar.place.calendar/hub.similar.place.calendar.component.html